// extracted by mini-css-extract-plugin
export default {"Header":"_Header--ST8u0","Row":"_Row--gu379"};